//UI Functions
var indexHero = document.querySelector(".index-hero");
var indexCard = document.querySelector(".index-card");
var indexHeader = document.querySelector(".index header");
var indexFooter = document.querySelector(".index footer");
var i = 0;
var txt = ' need';
var speed = 150;
var followText = document.getElementById("need");
var strikeText = document.getElementById("can");
var lazyLoadInstance = null;

function introSeq() {
  setTimeout(function() {
    strikeText.classList.add('strike');
  }, 1200);
  setTimeout(function() {
    followText.style.opacity = '1';
    indexHero.classList.remove('initial');
    indexHeader.classList.add('visible');
    indexFooter.classList.add('visible');
    indexCard.classList.remove('initial');
  }, 2000);
  setTimeout(function() {
    indexCard.classList.add('ender');
  }, 2600);
}

function introDefault() {
  strikeText.classList.add('strike');
  followText.style.opacity = '1';
  indexHero.classList.remove('initial');
  indexHeader.classList.add('visible');
  indexFooter.classList.add('visible');
  indexCard.classList.remove('initial');
  setTimeout(function() {
    indexCard.classList.add('ender');
  }, 600);
}

//Events and Listeners
function attachEventListeners() {
  var cards = document.querySelectorAll(".index-card .coming-soon");
  if (cards) {
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.addEventListener('click', function (e) {
        e.preventDefault();
        let ticker = this.querySelector('.ticker');
        ticker.classList.add('bump');
        setTimeout(function() {
          ticker.classList.remove('bump');
        }, 1000);
      })
    }
  }
  else {
    console.log('not found')
  }
}

//On Load Events
window.addEventListener('DOMContentLoaded', function () { //OnLoad Events
  attachEventListeners();

  // Initiate LazyLoad
  if (document.querySelector('body#mask')){
      lazyLoadInstance = new LazyLoad({
    });
  }

}, false);
